import React, {
  useEffect,
  useState
} from "react";

import BaseURL from "../../assets/utils/baseUrl";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";

import {
  Breadcrumb,
  Footer,
  Header,
  Sidebar
} from "../../components";

import "./style.scss";

import {
  useParams
} from "react-router-dom";

function BeritaDetail() {

  useDocumentTitle(
    "Informasi - BAPENDA BEKASI"
  );

  // =========================
  // PARAM
  // =========================

const secureUrl = (url) => {
  if (!url) return "";

  return url.replace("http://", "https://");
};

  const { id } = useParams();

  // =========================
  // STATE
  // =========================

  const [informasi,
    setInformasi] =
    useState(null);

  const [loading,
    setLoading] =
    useState(true);

  // =========================
  // FETCH DATA
  // =========================

  useEffect(() => {

    const controller =
      new AbortController();

    const getData =
      async () => {

        try {

          setLoading(true);

          const response =
            await fetch(

              BaseURL +
              "index.php/api/Berita?id=" +
              id,

              {
                method: "GET",

                headers: {
                  Accept:
                    "application/json",

                  "Content-Type":
                    "application/json",

                  // API KEY
                  "X-API-KEY":
                    process.env
                      .REACT_APP_API_KEY
                },

                signal:
                  controller.signal
              }
            );

          // =========================
          // VALIDASI RESPONSE
          // =========================

          if (!response.ok) {

            throw new Error(
              "HTTP Error " +
              response.status
            );
          }

          const result =
            await response.json();

          console.log(
            "DETAIL BERITA:",
            result
          );

          // =========================
          // VALIDASI DATA
          // =========================

          if (
            result &&
            result.status === true &&
            Array.isArray(
              result.data
            ) &&
            result.data.length > 0
          ) {

            setInformasi(
              result.data[0]
            );

          } else {

            setInformasi(null);
          }

        } catch (error) {

          if (
            error.name !==
            "AbortError"
          ) {

            console.error(
              "ERROR DETAIL:",
              error
            );
          }

          setInformasi(null);

        } finally {

          setLoading(false);
        }
      };

    if (id) {

      getData();
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    return () =>
      controller.abort();

  }, [id]);

  // =========================
  // LOADING
  // =========================

  if (loading) {

    return (

      <div className="page">

        <Header active="publikasi" />

        <div
          style={{
            padding: "40px",
            textAlign: "center"
          }}
        >
          Loading...
        </div>

        <Footer />

      </div>
    );
  }

  // =========================
  // DATA TIDAK ADA
  // =========================

  if (!informasi) {

    return (

      <div className="page">

        <Header active="publikasi" />

        <div
          style={{
            padding: "40px",
            textAlign: "center"
          }}
        >
          Data berita tidak ditemukan
        </div>

        <Footer />

      </div>
    );
  }

  // =========================
  // FORMAT KONTEN
  // =========================

  const kontenArr =
    informasi.konten

      ? informasi.konten
          .split("(_newline)")
          .filter(
            (item) =>
              item.trim() !== ""
          )

      : [];

  // =========================
  // RENDER
  // =========================

  return (

    <div className="page">

      <Header active="publikasi" />

      <main className="main-sb">

        <section className="content">

          <Breadcrumb
            path={
              informasi.judul ||
              "Detail Berita"
            }
            parent="berita"
          />

          <div className="informasi-detail-wrapper">

            {/* ========================= */}
            {/* TITLE */}
            {/* ========================= */}

            <p className="informasi-detail-title">

              {
                informasi.judul ||
                "-"
              }

            </p>

            {/* ========================= */}
            {/* DATE */}
            {/* ========================= */}

            <p className="informasi-detail-date">

              {
                informasi.created_date ||
                "-"
              }

              {" | "}

              {
                informasi.user ||
                "-"
              }

            </p>

            {/* ========================= */}
            {/* IMAGE */}
            {/* ========================= */}

            <div className="informasi-detail-image-wrapper">

             <img
  src={
    informasi.thumbnail
      ? secureUrl(informasi.thumbnail)
      : "/no-image.png"
  }
  className="informasi-detail-image"
  alt={
    informasi.judul ||
    "berita"
  }
  loading="lazy"
  onError={(e) => {
    e.target.src =
      "/no-image.png";
  }}
/>

            </div>

            {/* ========================= */}
            {/* CONTENT */}
            {/* ========================= */}

            <div className="informasi-detail-desc-wrapper">

              {
                kontenArr.length > 0 ? (

                  kontenArr.map(
                    (
                      item,
                      index
                    ) => (

                      <p
                        key={index}

                        className="informasi-detail-desc"
                      >

                        {item}

                      </p>
                    )
                  )

                ) : (

                  <p className="informasi-detail-desc">

                    Tidak ada konten

                  </p>
                )
              }

            </div>

          </div>

        </section>

        <Sidebar />

      </main>

      <Footer />

    </div>
  );
}

export default BeritaDetail;